import React from 'react';
import {exportCSVFile} from './CsvDownload';

class ImportCSV extends React.Component {
    constructor(props) {
        super(props);  
    }

 handleFiles=(event)=> {
     // Check for the various File API support.
     if (window.FileReader) {
         // FileReader are supported. 
         if(event.target.files[0])
             this.getAsText(event.target.files[0]);
         else
             alert('Please select CSV file...');
     } else {
         alert('FileReader are not supported in this browser.');
     }
 }

  getAsText=(fileToRead)=> {
      var reader = new FileReader();
      // Read file into memory as UTF-8      
      reader.readAsText(fileToRead);
      // Handle errors load
      reader.onload = this.loadHandler;
      reader.onerror = this.errorHandler;
  }

  loadHandler=(event)=> {
      var csv = event.target.result;
      this.processData(csv);
  }

  processData=(csv)=> {
      const {columName}=this.props;
      var allTextLines = csv.split(/\r\n|\n/);
      var lines = [];
      var error = [];
      var columnCheck=0;
      for (var i=0; i<allTextLines.length; i++) {
          var data = allTextLines[i].split(';')[0].split(',');
          if(i==0){
              columnCheck=data.length;
          }
          if(columnCheck===data.length && i!==0){ 
          //if(i!==0){ 
              let obj = {};
              for (let j = 0; j < data.length; j++) {
                  obj[columName[j]] =data[j]; 
              }
              lines.push(obj);
          }else{
              let obj = {};
              for (let j = 0; j < data.length; j++) {
                  obj[columName[j]] =data[j]; 
              }
              error.push(obj);

          }
      }
      // document.getElementById("upload").value='';
      this.props.getData(lines,error); 
  }

  errorHandler=(evt)=> {
      if(evt.target.error.name == 'NotReadableError') {
          alert('Canno\'t read file !');
      }
  }

  downloadCSVFormat=()=>{
      const {columnCSVTitle,fileName} = this.props;
      exportCSVFile(columnCSVTitle,fileName); 
  }

  render(){
      return(  
          <div className="uk-grid uk-width-medium-10-10" >
              <div className="uk-width-medium-1-2" style={{paddingTop:'6px',paddingBottom:'15px'}}>  
              Click to download CSV format for Import  
              </div>
              <div className="uk-width-medium-1-2" style={{paddingTop:'6px',paddingBottom:'15px'}}> 
                  <button onClick={this.downloadCSVFormat} style={{width: '240px'}} className="md-btn md-btn-primary md-btn-small" >Download CSV Format</button> 
              </div>
              <div className="uk-width-medium-1-2" style={{paddingTop:'6px'}}> 
              Choose CSV file 
              </div> 
              <div className="uk-width-medium-1-2" style={{paddingTop:'6px'}}>  
                  <input type="file" className="md-btn md-btn-primary md-btn-small"  id="upload" onChange={(e)=>this.handleFiles(e)} accept=".csv"/> 
              </div> 
          </div> 
      );
  }


}

export default ImportCSV;


// WEBPACK FOOTER //
// ./src/core/importCSV.js